import React, { useState } from "react";
import { App } from "../App/App";
import { createUseStyles } from "react-jss";
import { Button } from "@mui/material";
import {ProgressProvider} from "../progress/progressContext";
import { DemoMediaLibraryModal } from "./DemoMediaLibraryModal";

const useStyles = createUseStyles({
  container: {
    height: "100%",
    width: "100vw",
    display: "flex",
    flexDirection: "column"
  },
  appBar: {
    width: "100%",
    backgroundColor: "green",
    height: "120px",
    minHeight: "120px"
  },
});

export const AdminDemo = () => {
  const init = {
    appBar: {
      backgroundColor: "#0C0B0F",
      mode: "dark",
      exhibition: {
        name: "Forrige århundrets mote",
        description: "Bli inspirert av forrige århundrets mote!",
        url: "https://beta.virtueltmuseum.no/museum/12/exhibition/ff335e35-98ec-4e36-9c32-79428f917b69",
      },
      museum: {
        name: "Museene i Akershus",
        url: "https://beta.virtueltmuseum.no/museum/12",
      },
    },
    autoplay: { enabled: true },
    audioGuide: { enabled: true },
    sections: [
      {
        "backgroundFocus": {
          "x": -0.06666666666666665,
          "y": 0.660245183887916
        },
        "backgroundImage": "013AkPNRPrZ6",
        "containers": [
          {
            "backgroundColor": "#ffffffff",
            "kenBurns": {
              "x": 0.0,
              "y": 0.2,
              "zoom": 1.0
            },
            "blocks": [
              {
                "placeholder": "Klikk her for å skrive",
                "text": "{\"blocks\":[{\"key\":\"en211\",\"text\":\"\\nMuseene i Akershus\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":19,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"5rd6u\",\"text\":\"presenterer\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"5un3k\",\"text\":\"Fotoutstyr\\ni 1920\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":17,\"style\":\"BOLD\"},{\"offset\":0,\"length\":17,\"style\":\"FONT_SIZE_48\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                "type": "text"
              },
              {
                "placeholder": "Klikk her for å skrive",
                "text": "{\"blocks\":[{\"key\":\"en211\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"99v1f\",\"text\":\"SCROLL FOR Å LESE\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":17,\"style\":\"FONT_SIZE_12\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"db1p5\",\"text\":\"↓\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":1,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"7poq6\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                "type": "text"
              },
              {
                "enablePan": false,
                "enableZoom": false,
                "showToolbar": false,
                "type": "3d"
              }
            ],
            "borderRadius": true,
            "endColumn": 6,
            "horizontalAlign": "center",
            "startColumn": 4,
            "stepPosition": "bottom"
          },
          {
            "backgroundColor": "#fffffff2",
            "kenBurns": {
              "x": 0.25,
              "y": 0.45,
              "zoom": 1.85
            },
            "blocks": [
              {
                "placeholder": "Klikk her for å skrive",
                "text": "{\"blocks\":[{\"key\":\"fi2a6\",\"text\":\"Kamerautstyret du ser i bakgrunnen er mer enn 100 år gammelt. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":62,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 6,
            "horizontalAlign": "center",
            "startColumn": 5,
            "stepPosition": "bottom"
          }
        ],
        "gridSize": "nineColumns",
        "order": 1,
        "templateId": 5,
        "type": "sticky",
        "title": "Forside"
      },
      {
        "backgroundFocus": {
          "x": -0.042424242424242475,
          "y": 0.7552863765515179
        },
        "backgroundImage": "04RW1dGddh",
        "containers": [
          {
            "backgroundColor": "#000000b5",
            "kenBurns": {
              "x": -0.35,
              "y": 0.25,
              "zoom": 1.8,
              "effect": "spotlight"
            },
            "blocks": [
              {
                "placeholder": "Klikk her for å skrive",
                "text": "{\"blocks\":[{\"key\":\"en211\",\"text\":\"Kameraet tilhørte gårdeieren Niels Juel fra Hurdal, og han tok mange bilder  – i hvert fall til å være en hobbyfotograf tidlig på 1900-tallet.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":142,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":142,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 6,
            "horizontalAlign": "center",
            "startColumn": 2,
            "stepPosition": "bottom"
          },
          {
            "backgroundColor": "#0000009c",
            "kenBurns": {
              "x": 0.35,
              "y": -0.2,
              "zoom": 2.0,
              "effect": "pulse"
            },
            "blocks": [
              {
                "placeholder": "Klikk her for å skrive",
                "text": "{\"blocks\":[{\"key\":\"fi2a6\",\"text\":\"Men det var noe ganske annet å fotografere på Niels Juels tid, enn det er å ta bilder i dag.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":92,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":92,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 12,
            "horizontalAlign": "center",
            "startColumn": 8,
            "stepPosition": "bottom"
          },
          {
            "backgroundColor": "#000000a8",
            "kenBurns": {
              "x": 0.0,
              "y": 0.35,
              "zoom": 1.75,
              "effect": "lens"
            },
            "blocks": [
              {
                "placeholder": "Klikk her for å skrive",
                "text": "{\"blocks\":[{\"key\":\"ken3\",\"text\":\"Kameraet hadde et solid håndtak og utfellbar skinne, skreddersydd for krevende feltarbeid.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":103,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":103,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 10,
            "horizontalAlign": "center",
            "startColumn": 4,
            "stepPosition": "bottom"
          }
        ],
        "gridSize": "twelveColumns",
        "order": 2,
        "templateId": 5,
        "type": "sticky",
        "title": "Niels Juels kamera (Ken Burns)",
        "verticalAlign": "center",
        "excludeFromNav": false
      },
      {
        "backgroundColor": "#FCF1E3",
        "containers": [
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"a69n5\",\"text\":\"I dag tar vi over tusen milloner bilder i året, verden rundt. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":62,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"7qv2a\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5i153\",\"text\":\"For over 100 år siden måtte de fleste dra til et fotostudio med lyskastere og store, tunge fotoapprater for å bli fotografert. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":127,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"bln0s\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"4ivkt\",\"text\":\"Men ny teknologi og mer bærbare kamera åpnet nye muligheter for fotografi.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":74,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"1ifgq\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"82vj3\",\"text\":\"Dette benyttet Niels Juel seg av. Hans kamera tok bilder med glassplater som kom i små esker.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":93,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "center",
            "startColumn": 5
          }
        ],
        "minHeight": "50vh",
        "order": 3,
        "templateId": 2,
        "type": "content",
        "verticalAlign": "center"
      },
      {
        "backgroundColor": "#FCF1E3",
        "containers": [
          {
            "blocks": [
              {
                "autoPlay": false,
                "format": "video/mp4",
                "loop": true,
                "showControls": false,
                "size": "xl",
                "type": "video",
                "videoUrl": "019EE8EBk2fP8"
              },
              {
                "text": "{\"blocks\":[{\"key\":\"cb96t\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"6kdm7\",\"text\":\"En museumsansatt åpner en eske med glassplatenegativer fra 1900-tallet.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":71,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 8,
            "startColumn": 3
          }
        ],
        "minHeight": "100px",
        "order": 4,
        "type": "content",
        "verticalAlign": "center"
      },
      {
        "backgroundColor": "#fcf1e3ff",
        "containers": [
          {
            "blocks": [
              {
                "color": "#0C0B0F",
                "font": "'Libre Baskerville', serif",
                "imagePath": "013Aitiph5CK",
                "size": "xl",
                "textAlign": "center",
                "type": "image"
              }
            ],
            "endColumn": 8,
            "horizontalAlign": "center",
            "startColumn": 3
          },
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"4goel\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"8sfi\",\"text\":\"Glassplate-negativer gjorde fotoutstyret  litt mer bærbart enn tidligere.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":73,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"9pk4j\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"793jp\",\"text\":\"Da kunne flere ta bilder fra hverdagen, og fotografere utendørs.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":64,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8cm1u\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "startColumn": 5
          }
        ],
        "gridSize": "nineColumns",
        "minHeight": "100px",
        "order": 5,
        "type": "content",
        "verticalAlign": "center"
      },
      {
        "backgroundColor": "#b1cdcdff",
        "containers": [
          {
            "blocks": [
              {
                "color": "#0C0B0F",
                "font": "'Libre Baskerville', serif",
                "imagePath": "013Aitiph5CL",
                "margin": "40vh 0 0 0",
                "size": "xl",
                "type": "image"
              },
              {
                "text": "{\"blocks\":[{\"key\":\"2g0f1\",\"text\":\"Det ble lettere å fotografere steder og bygninger...\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":52,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"4m7dt\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"dfl7g\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 12,
            "horizontalAlign": "center",
            "startColumn": 6
          },
          {
            "blocks": [
              {
                "color": "#0C0B0F",
                "font": "'Libre Baskerville', serif",
                "imagePath": "013Aitiph5CM",
                "margin": "30vh 0 0 0",
                "size": "xl",
                "type": "image"
              },
              {
                "text": "{\"blocks\":[{\"key\":\"6jgc6\",\"text\":\"...utålmodige hunder...\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":23,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"1r08d\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 8,
            "horizontalAlign": "left",
            "startColumn": 2
          },
          {
            "blocks": [
              {
                "color": "#0C0B0F",
                "font": "'Libre Baskerville', serif",
                "imagePath": "013AkPNRPrhv",
                "margin": "30vh 0 0 0",
                "size": "xl",
                "type": "image"
              },
              {
                "text": "{\"blocks\":[{\"key\":\"6jgc6\",\"text\":\"...situasjoner og øyeblikk, både hverdag og fest.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":49,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"3t2s9\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"ee6m3\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 12,
            "horizontalAlign": "left",
            "startColumn": 6
          }
        ],
        "gridSize": "twelveColumns",
        "minHeight": "100vh",
        "order": 6,
        "type": "content",
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"3o0cb\",\"text\":\"Den norske hobbyfotografen Niels Juel eide på denne tiden et kamera kalt «Svenska Express».\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":91,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":91,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":91,\"style\":\"fontsize-20\"},{\"offset\":0,\"length\":91,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":91,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"1or3r\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 5,
            "verticalAlign": "bottom"
          }
        ],
        "minHeight": "25vh",
        "order": 7,
        "templateId": 2,
        "type": "content",
        "verticalAlign": "center"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "format": "video/mp4",
                "playbackConstant": 600,
                "type": "videoScroll",
                "videoUrl": "013Aiu4aiAmc"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 2
          },
          {
            "backgroundColor": "#503D45",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"cd0d2\",\"text\":\"Kameraet var et samarbeid mellom produsentene Hasselblad og Svensson i Göteborg, og ble først produsert i 1883.\\n\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":111,\"style\":\"color-rgb(255,255,255)\"},{\"offset\":0,\"length\":111,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":111,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":112,\"style\":\"bgcolor-transparent\"},{\"offset\":0,\"length\":112,\"style\":\"FONT_SIZE_18\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 9,
            "horizontalAlign": "left",
            "startColumn": 6
          },
          {
            "backgroundColor": "#EAE6E0",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"a3lpb\",\"text\":\"Hasselblad markedsførte kameraet i sine lokaler, og Svensson produserte dem på bestilling.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":90,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":90,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":90,\"style\":\"bgcolor-transparent\"},{\"offset\":0,\"length\":90,\"style\":\"color-#000000\"},{\"offset\":0,\"length\":90,\"style\":\"FONT_SIZE_18\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 9,
            "horizontalAlign": "left",
            "startColumn": 6
          },
          {
            "backgroundColor": "#503D45",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"3793m\",\"text\":\"Niels tok sannsynigvis over tusen bilder med kamereat, både hjemme i Hurdal, og på reiser til utlandet og i Norge.\\n\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":114,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":114,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":115,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":115,\"style\":\"bgcolor-transparent\"},{\"offset\":0,\"length\":115,\"style\":\"FONT_SIZE_18\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 9,
            "horizontalAlign": "left",
            "startColumn": 6
          },
          {
            "backgroundColor": "#EAE6E0",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"r8f9\",\"text\":\"Det ser overraskende pent ut til å være over 100 år gammelt, selv om tidens tann har lagt igjen et par skrap på læret.\\n\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":118,\"style\":\"fontsize-medium\"},{\"offset\":0,\"length\":118,\"style\":\"fontfamily-Work Sans\"},{\"offset\":0,\"length\":118,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":118,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":119,\"style\":\"color-#000000\"},{\"offset\":0,\"length\":119,\"style\":\"bgcolor-transparent\"},{\"offset\":0,\"length\":119,\"style\":\"FONT_SIZE_18\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 9,
            "horizontalAlign": "left",
            "startColumn": 6
          }
        ],
        "minHeight": "50vh",
        "order": 8,
        "templateId": 5,
        "type": "sticky",
        "verticalAlign": "top"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"5e58v\",\"text\":\"Kameraet er på størrelse med en brødrister, og ganske lett når det ikke er glassplater i det.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":93,\"style\":\"FONT_SIZE_20\"},{\"offset\":0,\"length\":93,\"style\":\"fontsize-medium\"},{\"offset\":0,\"length\":93,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":93,\"style\":\"fontsize-24\"},{\"offset\":0,\"length\":93,\"style\":\"color-rgb(12,11,15)\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 5,
            "verticalAlign": "center"
          }
        ],
        "minHeight": "25vh",
        "order": 9,
        "templateId": 2,
        "type": "content",
        "verticalAlign": "center"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "imagePath": "013Aiu4aiAzs",
                "margin": "15vh 0 0 0",
                "type": "image"
              }
            ],
            "endColumn": 8,
            "horizontalAlign": "left",
            "startColumn": 3
          }
        ],
        "order": 10,
        "type": "content"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"8c058\",\"text\":\"På innsiden av kameraet var mesteparten av plassen holdt av til glassplater, og i dette svenske vidunderet var det plass til 12 glassplater på det meste.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":153,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 5,
            "verticalAlign": "center"
          }
        ],
        "minHeight": "25vh",
        "order": 11,
        "templateId": 2,
        "type": "content",
        "verticalAlign": "center"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "imagePath": "013Aiu4aiAzr",
                "type": "image"
              }
            ],
            "endColumn": 8,
            "horizontalAlign": "left",
            "startColumn": 3
          }
        ],
        "order": 12,
        "type": "content"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"8c058\",\"text\":\"Men det var ikke mange som hadde råd til å være hobbyfotograf på 1920-tallet. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":78,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"bh01q\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"fev1t\",\"text\":\"Både glassplatene og fotoapparatene var for dyre for de aller fleste. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":69,\"style\":\"FONT_SIZE_20\"},{\"offset\":69,\"length\":1,\"style\":\"FONT_SIZE_24\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 5,
            "verticalAlign": "center"
          }
        ],
        "minHeight": "25vh",
        "order": 13,
        "templateId": 2,
        "type": "content",
        "verticalAlign": "center"
      },
      {
        "backgroundImage": "013Aiu4UmDep",
        "containers": [
          {
            "backgroundColor": "#ffffffed",
            "blocks": [
              {
                "alternatives": [
                  {
                    "alternative": "a",
                    "text": "Omtrent en dagslønn for en tjenestegutt"
                  },
                  {
                    "alternative": "b",
                    "text": "Omtrent en månedslønn for en tjenestegutt"
                  },
                  {
                    "alternative": "c",
                    "text": "Omtrent en halv årslønn for en tjenestegutt"
                  }
                ],
                "answer": "c",
                "question": "Hvor mye tror du fotoapparatet kostet på denne tiden?",
                "type": "quiz"
              }
            ],
            "borderRadius": true,
            "endColumn": 6,
            "horizontalAlign": "center",
            "startColumn": 5
          }
        ],
        "gridSize": "nineColumns",
        "order": 14,
        "templateId": 5,
        "type": "sticky"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"8c058\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"8ah6\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"2n3m1\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"cvoen\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"7ijoj\",\"text\":\"I dag kan vi se bildene på telefonen med en gang vi har tatt dem.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":65,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"d7l26\",\"text\":\"Men slik var det ikke for 100 år siden. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":40,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"7mhe0\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"725eb\",\"text\":\"Når Niels Juel hadde vært ute og tatt bilder, måtte han i gang med å fremkalle dem. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":84,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"5g8fh\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"51qcq\",\"text\":\"Han måtte altså overføre bildene fra glassplatene - til bildepapir.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":67,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"153o\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"b5j80\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"c369c\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5m0ok\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 5,
            "verticalAlign": "center"
          }
        ],
        "minHeight": "25vh",
        "order": 15,
        "templateId": 2,
        "type": "content",
        "verticalAlign": "center"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "format": "video/mp4",
                "playbackConstant": 800,
                "type": "videoScroll",
                "videoUrl": "013Aiu4aiAmd"
              }
            ],
            "endColumn": 8,
            "horizontalAlign": "left",
            "startColumn": 3
          },
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"18ma0\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"5ec6o\",\"text\":\"Dette er ikke en gammel fotoramme, men en kontaktprint-ramme.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":61,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":61,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":61,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":61,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":61,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":61,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"c6gjt\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"2ej8p\",\"text\":\"For å fremkalle bildene la fotografen glassplaten inn i denne rammen sammen med fotopapir.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":90,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":90,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":90,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":90,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":90,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":90,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"amvr5\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"3ttem\",\"text\":\"Når man løftet rammen opp mot lyset, ble motivet på glassplaten kopiert over på fotopapiret. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":93,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":93,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":93,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":93,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":93,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":93,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"79ogb\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"64bf9\",\"text\":\"Slik ble bildene skapt!​\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":24,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":24,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":24,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":24,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":24,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":24,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"25ipt\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"4c5o\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"avu79\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 5
          },
          {
            "blocks": [
              {
                "imagePath": "013AitqX8ASB",
                "margin": "15vh 0 0 0",
                "type": "image"
              }
            ],
            "endColumn": 9,
            "horizontalAlign": "left",
            "startColumn": 2
          },
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"e62ba\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"5cuso\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"51gs7\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"1laoc\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"bh4u7\",\"text\":\"Denne teknikken brukes faktisk fortsatt av folk som jobber med ikke-digitalt fotografi i dag.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":93,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":93,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":93,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":93,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":93,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":93,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"3jt9b\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"hh07\",\"text\":\"Men for en hobbyfotograf tidlig på 1900-tallet, var kontaktprint-rammen veldig viktig. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":87,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":87,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":87,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":87,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":87,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":87,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"d0lqe\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"6t1k4\",\"text\":\"Da slapp man å bruke penger på dyre kjemikalier og utstyr til mørkerom-fremkalling. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":84,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":84,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":84,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":84,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":84,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":84,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"ck97\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"7us6d\",\"text\":\"Med kontaktprint-rammen kunne man spare både tid og penger!\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":59,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":59,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":59,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":59,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":59,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":59,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"c1sun\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"87a0\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"be4cu\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"fb4vp\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 5
          },
          {
            "blocks": [
              {
                "autoPlay": true,
                "format": "video/mp4",
                "margin": "10vh 0 20vh 0",
                "playbackConstant": 800,
                "type": "video",
                "videoUrl": "013Aitiph5Gp"
              }
            ],
            "endColumn": 8,
            "horizontalAlign": "left",
            "startColumn": 3
          },
          {
            "blocks": [
              {
                "imagePath": "013Aitiph5CU",
                "margin": "15vh 0 0 0",
                "type": "image"
              }
            ],
            "endColumn": 9,
            "horizontalAlign": "left",
            "startColumn": 2
          }
        ],
        "order": 16,
        "type": "content"
      },
      {
        "backgroundImage": [
          {
            "image": "013Aitiph5CR",
            "x": 0.1120000000000001,
            "y": 0.1306666666666667
          },
          {
            "image": "013Aitiph5CS"
          },
          {
            "image": "013Aitiph5CT"
          }
        ],
        "containers": [
          {
            "backgroundColor": "#fcfcffb3",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"efhvj\",\"text\":\"Kontaktprint-rammen består egentlig ikke av så mange deler.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":59,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "center",
            "startColumn": 5
          },
          {
            "backgroundColor": "#ffffffb3",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"c479f\",\"text\":\"Det var ved hjelp av kontaktprint-rammen at Niel Juel raskt kunne lage kopier av bildene sine...\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":96,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":96,\"style\":\"bgcolor-rgba(255,255,255,0.067)\"},{\"offset\":0,\"length\":96,\"style\":\"fontsize-medium\"},{\"offset\":0,\"length\":96,\"style\":\"fontfamily-Work Sans, -apple-system, \\\"system-ui\\\", \\\"Segoe UI\\\", Helvetica, Arial, sans-serif, \\\"Apple Color Emoji\\\", \\\"Segoe UI Emoji\"},{\"offset\":0,\"length\":96,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "center",
            "startColumn": 5
          },
          {
            "backgroundColor": "#ffffffb3",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"fr6lj\",\"text\":\"...og dele dem ut til venner og familie, til stor glede.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":56,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":56,\"style\":\"bgcolor-rgba(255,255,255,0.067)\"},{\"offset\":0,\"length\":56,\"style\":\"fontsize-medium\"},{\"offset\":0,\"length\":56,\"style\":\"fontfamily-Work Sans, -apple-system, \\\"system-ui\\\", \\\"Segoe UI\\\", Helvetica, Arial, sans-serif, \\\"Apple Color Emoji\\\", \\\"Segoe UI Emoji\"},{\"offset\":0,\"length\":56,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "center",
            "startColumn": 5
          }
        ],
        "order": 17,
        "templateId": 6,
        "type": "sticky"
      },
      {
        "backgroundColor": "#ffffff",
        "containers": [
          {
            "blocks": [
              {
                "format": "video/mp4",
                "playbackConstant": 800,
                "type": "videoScroll",
                "videoUrl": "013Aiu4UmDog"
              }
            ],
            "endColumn": 10,
            "horizontalAlign": "left",
            "startColumn": 1
          },
          {
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"2odat\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"f21or\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"6dp29\",\"text\":\"Denne rulla var også blant utstyret til Niels Juel. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":52,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":52,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":52,\"style\":\"fontsize-18px\"},{\"offset\":0,\"length\":52,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":52,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":52,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"d12uu\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"j9h3\",\"text\":\"Kanskje brukte han rullen i overføringen av motivet fra glassplatenegativet til fotopapiret, eller for å gi litt ekstra glans til bildene.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":138,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":138,\"style\":\"bgcolor-rgb(255,255,255)\"},{\"offset\":0,\"length\":138,\"style\":\"fontsize-1.125rem\"},{\"offset\":0,\"length\":138,\"style\":\"fontfamily-Libre Baskerville\\\", serif\"},{\"offset\":0,\"length\":138,\"style\":\"fontsize-18\"},{\"offset\":0,\"length\":138,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"4d0g\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"ddq9p\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5q0mk\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"1c770\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "endColumn": 6,
            "horizontalAlign": "left",
            "startColumn": 5
          }
        ],
        "minHeight": "100px",
        "order": 18,
        "type": "content",
        "verticalAlign": "top"
      },
      {
        "backgroundImage": "013Aitiph584",
        "containers": [
          {
            "backgroundColor": "#FFFFFFE5",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"fkg5i\",\"text\":\"På cirka 30 år tok hobbyfotografen Niels Juel over 700 bilder.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":62,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":62,\"style\":\"fontsize-24\"},{\"offset\":0,\"length\":62,\"style\":\"fontfamily-Work Sans\"},{\"offset\":0,\"length\":62,\"style\":\"bgcolor-transparent\"},{\"offset\":0,\"length\":62,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 12,
            "horizontalAlign": "right",
            "startColumn": 8
          },
          {
            "backgroundColor": "#FFFFFFE5",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"dsl4p\",\"text\":\"Det var mye for en fotograf på hans tid. Men han kan nok ikke sammenlignes med deg og meg i dag.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":96,\"style\":\"color-rgb(12,11,15)\"},{\"offset\":0,\"length\":96,\"style\":\"fontsize-24\"},{\"offset\":0,\"length\":96,\"style\":\"fontfamily-Work Sans\"},{\"offset\":0,\"length\":96,\"style\":\"bgcolor-transparent\"},{\"offset\":0,\"length\":96,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 7,
            "horizontalAlign": "left",
            "startColumn": 2
          }
        ],
        "gridSize": "twelveColumns",
        "order": 19,
        "type": "sticky"
      },
      {
        "backgroundImage": "013Aiu4UmDaY",
        "containers": [
          {
            "backgroundColor": "#FFFFFFE5",
            "blocks": [
              {
                "text": "{\"blocks\":[{\"key\":\"5ss7b\",\"text\":\"Selv folk tok færre bilder før, lå det kanskje mer arbeid og tanke bak enn det gjør i bildene vi har på telefonen?\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":114,\"style\":\"fontsize-24\"},{\"offset\":0,\"length\":114,\"style\":\"fontfamily-Work Sans\"},{\"offset\":0,\"length\":114,\"style\":\"color-#000000\"},{\"offset\":0,\"length\":114,\"style\":\"bgcolor-transparent\"},{\"offset\":0,\"length\":114,\"style\":\"FONT_SIZE_20\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                "type": "text"
              }
            ],
            "borderRadius": true,
            "endColumn": 6,
            "horizontalAlign": "right",
            "startColumn": 5,
            "stepPosition": "bottom",
            "verticalAlign": "bottom"
          }
        ],
        "order": 20,
        "type": "sticky"
      }
    ]
  };
  const classes = useStyles();
  const [data, setData] = useState(init);
  const [showSidePanel, setShowSidePanel] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  const [mediaModalState, setMediaModalState] = useState({
    open: false,
    mediaType: "image",
    callback: null,
  });

  const handleMediaSelect = (mediaType, callback) => {
    setMediaModalState({
      open: true,
      mediaType,
      callback,
    });
  };

  return (
    <div className={classes.container}>
      <div className={classes.appBar}>App bar</div>
      <ProgressProvider>
        <App
          data={data}
          adminMode={!showPreview}
          onMediaSelect={handleMediaSelect}
          onChange={(data) => {
            console.log(data);
            setData(data);
          }}
          sidePanel={showSidePanel}
        />
      </ProgressProvider>
      <DemoMediaLibraryModal
        open={mediaModalState.open}
        mediaType={mediaModalState.mediaType}
        onClose={() => setMediaModalState((prev) => ({ ...prev, open: false }))}
        onSelect={(id) => {
          if (mediaModalState.callback) {
            mediaModalState.callback(id);
          }
        }}
      />
      <Button
        sx={{ position: "fixed", bottom: 40, right: 120, zIndex: 1100 }}
        onClick={() => setShowSidePanel(!showSidePanel)}
      >
        Toggle sidepanel
      </Button>
      <Button
        sx={{ position: "fixed", bottom: 40, right: 420, zIndex: 1100 }}
        onClick={() => setShowPreview(!showPreview)}
      >
        Toggle preview
      </Button>
    </div>
  );
};
